export default {"src":"/_next/static/media/iranian-products-icon.9df5048d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};